/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// src/components/WinRateCalculator/useWinRate.js
import { useMemo } from "react";

export default function useWinRate({ growthGoal: G, riskPerTrade: r, numTrades: N, splits }) {
  return useMemo(() => {
    let contributions = [];
    let A = 1;  // fallback if no splits

    if (splits) {
      const { w1,w2,w3, R1,R2,R3, q1,q2,q3 } = splits;
      const d1 = w1/100, d2 = w2/100, d3 = w3/100;
      const p1 = q1/100, p2 = q2/100, p3 = q3/100;

      // profit if you only reach TP1, TP2, TP3
      const profit1 =   d1 * R1;
      const profit2 =  (d1 * R1) + (d2 * R2);
      const profit3 =  (d1 * R1) + (d2 * R2) + (d3 * R3);

      // each contribution = probability × profit
      const c1 = p1 * profit1;
      const c2 = p2 * profit2;
      const c3 = p3 * profit3;

      contributions = [
        { label: "q₁", q: q1, profit: profit1, contrib: c1 },
        { label: "q₂", q: q2, profit: profit2, contrib: c2 },
        { label: "q₃", q: q3, profit: profit3, contrib: c3 },
      ];
      A = c1 + c2 + c3;
    }

    // required hit-rate
    const pMin = (1 + G/(N * r)) / (1 + A);

    return {
      A,
      pMin: Math.min(Math.max(pMin * 100, 0), 100),
      contributions,
    };
  }, [G, r, N, splits]);
}
